module.exports = __webpack_public_path__ + "static/media/profiling.0e822d81.svg";